import { createFieldSelectorHook } from 'src/lib/sweetState';
import { PerformanceStore } from './PerformanceStore';

export const useGlobalBenchmarkConfig = createFieldSelectorHook(
  PerformanceStore,
  'globalBenchmarkConfig'
);
